import { allocationMetricOptions, deliveredMetricOptions } from 'components/common/DrilldownReports/consts';
import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';
import { CampaignPlanAllocationReportConfig } from 'components/common/types/CampaignPlan.types';
import { AllocationMetricId } from 'components/common/Modals/ShareCampaignPlanModal/ShareCampaignPlanModal.types';

const plannedMetricTypeToConfigKey: Partial<Record<MetricType, AllocationMetricId>> = {
  [MetricType.SOT]: 'sot',
  [MetricType.IMPRESSIONS]: 'impressions',
  [MetricType.PRICE_INDEXED]: 'indexedPrice',
  [MetricType.PRICE_GROSS]: 'grossPrice',
  // [MetricType.REPETITIONS]: 'repetitions',
};

const deliveredMetricTypeToConfigKey: Partial<Record<MetricType, AllocationMetricId>> = {
  [MetricType.DELIVERED_SOT]: 'sot',
  [MetricType.DELIVERED_IMPRESSIONS]: 'impressions',
  // [MetricType.DELIVERED_PRICE_INDEXED]: 'indexedPrice',
  // [MetricType.DELIVERED_PRICE_GROSS]: 'grossPrice',
  [MetricType.DELIVERED_PLAYS]: 'repetitions',
};

export const getAllocationReportMetricOptions = (
  allocationReportConfig: CampaignPlanAllocationReportConfig | undefined,
  withDeliveredMetrics: boolean = false,
): MetricOption[] => {
  if (!allocationReportConfig) {
    return [];
  }

  const metricOptions = withDeliveredMetrics
    ? [...allocationMetricOptions, ...deliveredMetricOptions]
    : allocationMetricOptions;

  return metricOptions.filter(({ code }) => {
    if (code === MetricType.FRAMES) {
      return true;
    }

    const plannedConfigKey = plannedMetricTypeToConfigKey[code];

    if (plannedConfigKey) {
      return allocationReportConfig[plannedConfigKey]?.planned;
    }

    const deliveredConfigKey = deliveredMetricTypeToConfigKey[code];

    if (deliveredConfigKey) {
      return allocationReportConfig[deliveredConfigKey]?.delivered;
    }

    return false;
  });
};
